import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";

// import images
import home4 from "../../assets/images/home/home-4.png";
import img1 from "../../assets/images/about/about-1.png";
import img2 from "../../assets/images/about/about-2.png";
import img3 from "../../assets/images/about/about-3.png";
import img4 from "../../assets/images/about/about-4.png";
import img5 from "../../assets/images/about/about-5.png";
import useLang from "hooks/useLang";

AOS.init({
  duration: 1800,
});

const WhyUs = () => {
  const { lang } = useLang();

  return (
    <React.Fragment>
      <section className="section work" id="work-adinata">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="sec-hd-custom">
                <h1 className="sec-title">{lang.why_us.section_title}</h1>
              </div>
            </Col>
          </Row>
          <p>{lang.why_us.section_detail}</p>
          <Row className="align-items-center">
            <Col lg={6}>
              <div className="work-pra">
                <h4 className="my-4">{lang.why_us.list_title}</h4>
                <ul className="inline-item">
                  <li className="list-inline-item">
                    <i className="uil uil-bell"></i>
                    <div>
                      <h5>{lang.why_us.list_1_title}</h5>
                      <p className="text-muted">{lang.why_us.list_1_detail}</p>
                    </div>
                  </li>
                  <li className="list-inline-item">
                    <i className="uil uil-star"></i>
                    <div>
                      <h5>{lang.why_us.list_2_title}</h5>
                      <p className="text-muted">{lang.why_us.list_2_detail}</p>
                    </div>
                  </li>
                  <li className="list-inline-item">
                    <i className="uil uil-envelope-minus"></i>
                    <div>
                      <h5>{lang.why_us.list_3_title}</h5>
                      <p className="text-muted">{lang.why_us.list_3_detail}</p>
                    </div>
                  </li>
                  <li className="list-inline-item">
                    <i className="uil uil-heart-alt"></i>
                    <div>
                      <h5>{lang.why_us.list_4_title}</h5>
                      <p className="text-muted">{lang.why_us.list_4_detail}</p>
                    </div>
                  </li>
                  <li className="list-inline-item">
                    <i className="uil uil-heart-alt"></i>
                    <div>
                      <h5>{lang.why_us.list_5_title}</h5>
                      <p className="text-muted">{lang.why_us.list_5_detail}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={6} data-aos="fade-right">
              <div className="testimonial-contaent">
                <div className="testimonial-right">
                  <div className="testimonial-circle">
                    <div className="media">
                      <img src={home4} className="img-fluid" alt="" />
                    </div>
                    <span className="ring1 animate-v2">
                      <img src={img1} className="img-fluid" alt="" />
                    </span>
                    <span className="ring2 animate-v3">
                      <img src={img2} className="img-fluid" alt="" />
                    </span>
                    <span className="ring3 animate-v2">
                      <img src={img3} className="img-fluid" alt="" />
                    </span>
                    <span className="ring4 animate-v3">
                      <img src={img4} className="img-fluid" alt="" />
                    </span>
                    <span className="ring5 animate-v2">
                      <img src={img5} className="img-fluid" alt="" />
                    </span>
                    <span className="ring6 animate-v3"></span>
                    <span className="ring7 animate-v2"></span>
                    <span className="ring8 animate-v3"></span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default WhyUs;
